import React from 'react'
import ListDropSortableItems from './ListDropSortableItems'
import ListDropZone from './ListDropZone'

const ConditionalWrapper = ({ wrapper, children }) => wrapper ? wrapper(children) : children


const ListDropItems = ({
    listId, 
    title = '',
    items, 
    order,
    itemType,
    dndType=false,
    displayDropzones,
    conditionalWrapper = false,
    ChildSwitchItem,
    params=false,
    basicUrl=false,
    canDropCallback=false,
    canEdit = false,
    canDelete = false,  
    addItem,
    reorderItem,
    deleteItem = false,
}) => {
    const wrapper = conditionalWrapper ? conditionalWrapper(title) : false

    return (
        displayDropzones ? (
            <ListDropZone
                listId={listId}
                itemType={itemType}
                dndType={dndType}
                wrapper={wrapper}
                canDropCallback={canDropCallback}
                addItem={addItem}
            />
        ) : (
            <ConditionalWrapper wrapper={wrapper}>
                <ListDropSortableItems
                    listId={listId}
                    title={title}
                    items={items}
                    order={order}
                    itemType={itemType}
                    dndType={dndType}
                    params={params}
                    basicUrl={basicUrl}
                    ChildSwitchItem={ChildSwitchItem}
                    canEdit={canEdit}
                    canDelete={canDelete}
                    reorderItem={reorderItem}
                    deleteItem={deleteItem}
                />
            </ConditionalWrapper>
        )
    )
}

export default ListDropItems